import { render, staticRenderFns } from "./AttachmentsUploader.vue?vue&type=template&id=9ef91c76&"
import script from "./AttachmentsUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentsUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports